module.exports = __webpack_public_path__ + "media/images/icons/flags/BQ-1-bd08683a6e4bf03ee7f633d740bf122c.svg";